import { RoomServiceOutlineIcon } from './RoomServiceOutlineIcon';

/**
 * author: Google
 * id A94493FF-30FD-4490-8ABC-F6F03F958D17
 * name room-service-outline
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/room-service-outline.svg
 * tags
 */
export const CallBellOutlineIcon = RoomServiceOutlineIcon;
export default CallBellOutlineIcon